export default ['POST', 'GET', 'PUT', 'DELETE'];
